import { ParentControls } from '../types';
import { getSupabase } from './supabaseClient';

const TABLE = 'parent_controls';

function toParentControls(row: any): ParentControls {
  return {
    userId: row.user_id,
    maxStoryLength: row.max_story_length,
    excludedThemes: row.excluded_themes || [],
    monthlyStoryLimit: row.monthly_story_limit,
    dailySoftLimit: row.daily_soft_limit,
  };
}

export const parentControlsService = {
  async getControls(userId: string): Promise<ParentControls | null> {
    const { data, error } = await getSupabase()
      .from(TABLE)
      .select('*')
      .eq('user_id', userId)
      .maybeSingle();
    if (error || !data) return null;
    return toParentControls(data);
  },

  async saveControls(controls: ParentControls): Promise<void> {
    const { error } = await getSupabase()
      .from(TABLE)
      .upsert({
        user_id: controls.userId,
        max_story_length: controls.maxStoryLength,
        excluded_themes: controls.excludedThemes,
        monthly_story_limit: controls.monthlyStoryLimit,
        daily_soft_limit: controls.dailySoftLimit,
        updated_at: new Date().toISOString(),
      }, { onConflict: 'user_id' });
    if (error) throw new Error(error.message);
  },

  /** Returns true if the user has NOT exceeded monthly cap */
  async isWithinMonthlyLimit(userId: string, storyCountThisMonth: number): Promise<boolean> {
    const controls = await this.getControls(userId);
    if (!controls) return true;
    return storyCountThisMonth < controls.monthlyStoryLimit;
  },
};
